export class BoutiqueFacture {
    /**
     * Constructeut de l'objet
     * @param row Paramètres du constructeur
     */
    constructor(row) {
        if (row) {
            const { idBoutiqueFacture, idCommande } = row;
            this.idBoutiqueFacture = idBoutiqueFacture;
            this.idCommande = idCommande;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91dGlxdWVGYWN0dXJlLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQm91dGlxdWVGYWN0dXJlLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sT0FBTyxlQUFlO0lBVzNCOzs7T0FHRztJQUNILFlBQW1CLEdBQTZCO1FBQy9DLElBQUksR0FBRyxFQUFFO1lBQ1IsTUFBTSxFQUFFLGlCQUFpQixFQUFFLFVBQVUsRUFBRSxHQUFHLEdBQUcsQ0FBQztZQUM5QyxJQUFJLENBQUMsaUJBQWlCLEdBQUcsaUJBQWlCLENBQUM7WUFDM0MsSUFBSSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUM7U0FDN0I7SUFDRixDQUFDO0NBQ0QifQ==